import React from 'react';
import './index.css';
import { NavLink, Link } from "react-router-dom";

export default function Nav() {
    return (
        <nav>
            <NavLink to='/' className={({isActive})=> isActive? 'active' : ''}>Home</NavLink>
            <NavLink to='/projects' className={({isActive})=> isActive? 'active' : ''}>Projects</NavLink>
            <NavLink to='/About' className={({isActive})=> isActive? 'active' : ''}>About</NavLink>
            <Link to='/Contact' className="nav-cta">Contact</Link>
        </nav>
    )
}
